<template>
    <div>
        <CollapseConfirmData
            :code-id="code"
            @removeService="removeService"
        >
            <template #content>
                <div class="grid lg:gap-x-4 grid-cols-1 lg:grid-cols-2">
                    <ResultList>
                        <li class="flex justify-between">
                            <p>目前保單價值準備金</p>
                            <span>{{ data?.before.valReserve && addComma(data?.before.valReserve) }}</span>
                        </li>
                        <li class="flex justify-between text-gray-900">
                            <p>本次欲提領</p>
                            <span>{{ data?.after.valReserve && addComma(data?.after.valReserve) }}</span>
                        </li>
                    </ResultList>
                </div>
            </template>
        </CollapseConfirmData>
    </div>
</template>

<script>
import { ref, toRef } from 'vue';
import CollapseConfirmData from '@/components/collapse/CollapseConfirmData.vue';
import ResultList from '@/components/template/ResultList.vue';
import { addComma } from '@/utils/number/addComma';

export default {
    name: 'AEData',
    components: {
        CollapseConfirmData,
        ResultList
    },
    props: {
        result: {
            type: Object,
            required: true,
        }
    },
    emits: ['removeService'],
    setup(props, { emit }) {
        const data = toRef(props, 'result');
        const code = ref('AE');
        const removeService = () => {
            emit('removeService', code.value);
        };

        return {
            code,
            data,
            removeService,
            addComma
        };
    },
};
</script>
